import ImpressionDivWrapper from '@/components/Common/ImpressionDivWrapper';
import PointServiceCard from './PointServiceCard';
import RoamingPass from './RoamingPass';
import { NolPromotionStoreCtx } from '@/stores/NolPromotionStore';
import useIsomorphicEffect from '@/utils/useIsomorphicEffect';
import { observer } from 'mobx-react-lite';
import React, { FC, useContext, useRef } from 'react';
import styles from '../benefits.module.scss';
import NolCouponCard from './NolCouponCard';
import NolCardCashback from './NolCardCashback';

const Benefits: FC = () => {
  const store = useContext(NolPromotionStoreCtx);
  const cardRef1 = useRef<HTMLDivElement>(null);
  const cardRef2 = useRef<HTMLDivElement>(null);
  useIsomorphicEffect(() => {
    store.anchorTab0Ref = cardRef1;
    store.anchorTab1Ref = cardRef2;
  }, []);
  return (
    <div className={styles.container}>
      <div className={styles.title}>
        NOL에서 지금 받는 <br />
        NOL 카드 이벤트
      </div>
      {/* card */}
      <div className={styles.cardsContainer}>
        <div className={styles.firstCard}>
          <ImpressionDivWrapper
            className={styles.impressionWrapper}
            logData={{
              pageName: store.pageName,
              objectContainer: 'NOL에서 지금 받는 NOL 이벤트 혜택',
              motherPageVersion: store.version,
              motherPageSectionType: '혜택',
              motherPageSectionName: 'NOL 카드 전용 13만원 할인 웰컴 쿠폰팩 제공',
            }}
          >
            <NolCouponCard />
          </ImpressionDivWrapper>
        </div>
        <div className={styles.secondCard} ref={cardRef1}>
          <ImpressionDivWrapper
            className={styles.impressionWrapper}
            logData={{
              pageName: store.pageName,
              objectContainer: 'NOL에서 지금 받는 NOL 이벤트 혜택',
              motherPageVersion: store.version,
              motherPageSectionType: '혜택',
              motherPageSectionName: 'NOL카드',
            }}
          >
            <NolCardCashback />
          </ImpressionDivWrapper>
        </div>
        <div className={styles.thirdCard} ref={cardRef2}>
          <ImpressionDivWrapper
            className={styles.impressionWrapper}
            logData={{
              pageName: store.pageName,
              objectContainer: 'NOL에서 지금 받는 NOL 이벤트 혜택',
              motherPageVersion: store.version,
              motherPageSectionType: '혜택',
              motherPageSectionName: 'NOL 인터파크/트리플 계정 전환하면 최대 22,000P 제공',
            }}
          >
            <PointServiceCard />
          </ImpressionDivWrapper>
        </div>
        <div className={styles.fourthCard}>
          <ImpressionDivWrapper
            className={styles.impressionWrapper}
            logData={{
              pageName: store.pageName,
              objectContainer: 'NOL에서 지금 받는 NOL 이벤트 혜택',
              motherPageVersion: store.version,
              motherPageSectionType: '혜택',
              motherPageSectionName: 'NOL 카드 회원은 로밍패스 1년 가입비 0원 & 첫 구매 할인',
            }}
          >
            <RoamingPass />
          </ImpressionDivWrapper>
        </div>
      </div>
    </div>
  );
};

export default observer(Benefits);
